export default __webpack_public_path__ + "static/media/arrow_icon_green.ca6d1b59.svg";